module.exports = __webpack_public_path__ + "static/media/3.183da7d3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/ruined/3.wav
// module id = 506
// module chunks = 0